import { render, staticRenderFns } from "./ColorChip.vue?vue&type=template&id=2bbd72cf&scoped=true"
import script from "./ColorChip.vue?vue&type=script&lang=js"
export * from "./ColorChip.vue?vue&type=script&lang=js"
import style0 from "./ColorChip.vue?vue&type=style&index=0&id=2bbd72cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbd72cf",
  null
  
)

export default component.exports